import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { SubmissionError } from 'redux-form';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { contactActions as nucleusContactActions, nucleusConstants, contactModels } from '@lifesize/nucleus';
import modalActions from 'actions/FullScreenModal';
import ContactForm from 'components/ContactModal/ContactForm';
import { loadMissingMeetingInfo, selectContact } from 'utils/contact-utils';

// property = field name
// message key = error type from nucleus
const messages = {
  generic: defineMessages({
    generic: {
      id: 'components.contactForm.name.genericError',
      defaultMessage: 'Unable to create contact.'
    }
  }),
  contactExists: defineMessages({
    contactExists: {
      id: 'components.contactForm.name.contactExists',
      defaultMessage: 'You cannot create a contact using an existing meeting extension.'
    }
  }),
  name: defineMessages({
    [nucleusConstants.VALIDATE_DUPLICATE]: {
      id: 'components.contactForm.name.duplicateError',
      defaultMessage: '{value} already exists. Please choose a different name.'
    }
  }),
  sipUri: defineMessages({
    [nucleusConstants.VALIDATE_DUPLICATE]: {
      id: 'components.contactForm.sipUri.duplicateError',
      defaultMessage: 'You already have a contact with these Calling Details.'
    }
  })
};

function mapDispatchToProps(dispatch, { intl, history }) {
  return {
    saveContact: (contactObj) =>
      new Promise((resolve, reject) => {
        const contact = Object.assign(new contactModels.User(), contactObj);
        Promise.resolve(dispatch(nucleusContactActions.validateContact(contact)))
          .then(() => {
            dispatch(nucleusContactActions.saveContact(contact))
              .then((newContact) => {
                loadMissingMeetingInfo(dispatch, newContact);
                selectContact(newContact, history.push);
                resolve(newContact);
              })
              .catch((err) => {
                const errorObj = {};
                if (err) {
                  if (err.resCode === '-7') {
                    errorObj.sipUri = intl.formatMessage(messages.contactExists.contactExists);
                  } else {
                    errorObj.name = intl.formatMessage(messages.generic.generic);
                  }
                }
                /* eslint-disable no-underscore-dangle */
                errorObj._error = 'Creating a contact failed';
                /* eslint-enable no-underscore-dangle */
                reject(new SubmissionError(errorObj));
              });
          })
          .catch((error) => {
            const errorObj = {};
            error.forEach((err) => {
              errorObj[err.context.key] =
                messages[err.context.key] && messages[err.context.key][err.type]
                  ? intl.formatMessage(messages[err.context.key][err.type], { value: err.context.value })
                  : err.type;
            });
            /* eslint-disable no-underscore-dangle */
            errorObj._error = 'Creating a contact failed';
            /* eslint-enable no-underscore-dangle */
            reject(new SubmissionError(errorObj));
          });
      }),
    handleCancel: () => {
      dispatch(modalActions.closeFullScreenModal());
    }
  };
}
const mapStateToProps = (state, ownProps) => {
  const contact = ownProps.contactObj || _get(state, 'app.contactModal.contactObj') || {};

  return {
    initialValues: _get(state, 'app.contactModal.contactObj'),
    contact
  };
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContactForm)));
